import { Controller } from "@hotwired/stimulus";

// A line under a shadcn select naming the chosen record's id with a link to it ("ID 5 · Edit plan type").
// `records` maps each option value to { id, url }; hides while nothing is selected.
export default class extends Controller {
  static targets = ["line", "id", "link"];
  static values = { records: Object };

  connect() {
    this.update();
  }

  update() {
    const input = this.element.querySelector('[data-select-target="hiddenInput"]');
    const record = input ? this.recordsValue[input.value] : null;

    this.lineTarget.hidden = !record;
    if (!record) return;

    this.idTarget.textContent = `ID ${record.id}`;
    this.linkTarget.href = record.url;
  }
}
